import { ModalLayout } from '@starsoft/common/components';
import { ModalsKey } from '@/enums/modalsKey';
import { useUserAccount } from '@/api/user/queries';
import useTranslation from 'next-translate/useTranslation';
import WithdrawRolloverRequired from '../RolloverRequired';
import { useSearchParams } from '@starsoft/common/hooks';
import { ModalWithVersion } from '@/components/core/Modal/WithVersion';

export default function WithdrawVerifyModal() {
  const { t } = useTranslation('common');
  const { isAuthorized } = useUserAccount();
  const searchParams: URLSearchParams = useSearchParams();
  const coinId: string | null = searchParams.get('coin_id');

  return (
    <ModalWithVersion
      modal={ModalsKey.RolloverRequired}
      title={t('cant_withdraw_label')}
      condition={isAuthorized && !!coinId}
      fitContent
      smallMobilePadding
    >
      <WithdrawRolloverRequired />
    </ModalWithVersion>
  );
}
